import { ConfirmDialog } from "../shared/ConfirmDialog";

export const EliminarValorAtributoDialog = ({ visible, onCancel, onConfirm, valor }) => (
    <ConfirmDialog
        visible={visible}
        onCancel={onCancel}
        onConfirm={onConfirm}
        header="Eliminar Valor"
        message={`¿Realmente desea eliminar el valor "${valor?.valor || valor?.nombre || ''}"? Esta acción no se puede deshacer.`}
    />
);